import React, { useState } from 'react';
import { useLocation, useHistory } from "react-router-dom";
import './Login.css';
import { loginUser } from '../services/login';
import { usePromiseTracker } from "react-promise-tracker";
import { Oval } from 'react-loading-icons';
import { confirmAlert } from 'react-confirm-alert';
import { useAuth } from '../AuthContext/AuthContext';

export default function Login() {
    const { setDispatch } = useAuth();
    const [CUI, setCUI] = useState('');
    const [Clave, setPassword] = useState('');
    const [Nacimiento, setFecha] = useState('');
    let history = useHistory(); 
    const { promiseInProgress } = usePromiseTracker(); 
    
    // Obtener bgId desde query parameters
    const query = new URLSearchParams(useLocation().search);
    const bgId = parseInt(query.get('bgId'), 10) || 1; // Valor por defecto: 1
    const backgroundImage = `/principal/fondo15.jpg`;

    const mensaje = (respuesta) => {
        confirmAlert({
            customUI: ({ onClose }) => (
                <div className='custom-ui center-text'>
                    <center><h3>{respuesta}</h3></center>
                    <center>
                        <button className="button-modal-single" onClick={onClose}>
                            Aceptar
                        </button>
                    </center>
                </div>
            )
        });
    };

    const login = () => {
        loginUser({ CUI, Clave, Nacimiento }).then(response => {
            const { cif, nombre, token, status } = response;
            setDispatch({ type: 'LOGIN', payload: { cif, nombre, token, status } });

            switch (parseInt(status, 10)) {
                case 0: history.push("/transmision"); break;
                case 1: history.push("/admin"); break;
                case 2: history.push("/audit"); break;
                default: mensaje("Las credenciales ingresadas son inválidas. Por favor vuelva a intentarlo.");
            }
        });
    };
    
    return (
        <div>
            <div className="main other-component login-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
                <div className="login-wrapper login-padding">
                    <div className='login-style'>
                        <div>
                        <img src="https://guadalupanabucket.s3.us-east-2.amazonaws.com/logo_header.png" className="logo_login" alt="Guadalupana"></img>
                        </div>
                        <label>
                            <div className="login-label">CUI</div>
                            <input className="input" placeholder="CUI" type="number" onChange={e => setCUI(e.target.value)} />
                        </label>
                        <label>
                            <div className="login-label">Contraseña</div>
                            <input className="input" placeholder="Contraseña" type="password" onChange={e => setPassword(e.target.value)} />
                        </label>
                        <label>
                            <div className="login-label">Fecha nacimiento</div>
                            <input type="date" placeholder="MM/DD/YYYY" onChange={e => setFecha(e.target.value)} />
                        </label>
                        <div>
                            <button className="button" onClick={login} disabled={promiseInProgress}> 
                                {promiseInProgress ? "Iniciando..." : "Iniciar sesión"} 
                                {promiseInProgress && <Oval className="loading-icon" />} 
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
